'use strict'; // --------------------------------------------------------------------
// Imports
// --------------------------------------------------------------------

var _toConsumableArray = require("/home/amt/agmtv2/autographa-mt/node_modules/@babel/runtime/helpers/toConsumableArray");

var _possibleConstructorReturn = require("/home/amt/agmtv2/autographa-mt/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/home/amt/agmtv2/autographa-mt/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/home/amt/agmtv2/autographa-mt/node_modules/@babel/runtime/helpers/inherits");

var _classCallCheck = require("/home/amt/agmtv2/autographa-mt/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/home/amt/agmtv2/autographa-mt/node_modules/@babel/runtime/helpers/createClass");

var UnicodeCategories = require('../third_party/UnicodeCategories');

var common = require('./common'); // --------------------------------------------------------------------
// Private stuff
// --------------------------------------------------------------------
// General stuff


var PExpr =
/*#__PURE__*/
function () {
  function PExpr() {
    _classCallCheck(this, PExpr);

    if (this.constructor === PExpr) {
      throw new Error("PExpr cannot be instantiated -- it's abstract");
    }
  } // Set the `source` property to the interval containing the source for this expression.


  _createClass(PExpr, [{
    key: "withSource",
    value: function withSource(interval) {
      if (interval) {
        this.source = interval.trimmed();
      }

      return this;
    }
  }]);

  return PExpr;
}(); // Any


var any = Object.create(PExpr.prototype); // End

var end = Object.create(PExpr.prototype); // Terminals

var Terminal =
/*#__PURE__*/
function (_PExpr) {
  _inherits(Terminal, _PExpr);

  function Terminal(obj) {
    var _this;

    _classCallCheck(this, Terminal);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Terminal).call(this));
    _this.obj = obj;
    return _this;
  }

  return Terminal;
}(PExpr); // Ranges


var Range =
/*#__PURE__*/
function (_PExpr2) {
  _inherits(Range, _PExpr2);

  function Range(from, to) {
    var _this2;

    _classCallCheck(this, Range);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(Range).call(this));
    _this2.from = from;
    _this2.to = to;
    return _this2;
  }

  return Range;
}(PExpr); // Parameters


var Param =
/*#__PURE__*/
function (_PExpr3) {
  _inherits(Param, _PExpr3);

  function Param(index) {
    var _this3;

    _classCallCheck(this, Param);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(Param).call(this));
    _this3.index = index;
    return _this3;
  }

  return Param;
}(PExpr); // Alternation


var Alt =
/*#__PURE__*/
function (_PExpr4) {
  _inherits(Alt, _PExpr4);

  function Alt(terms) {
    var _this4;

    _classCallCheck(this, Alt);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(Alt).call(this));
    _this4.terms = terms;
    return _this4;
  }

  return Alt;
}(PExpr); // Extend is an implementation detail of rule extension


var Extend =
/*#__PURE__*/
function (_Alt) {
  _inherits(Extend, _Alt);

  function Extend(superGrammar, name, body) {
    var _this5;

    _classCallCheck(this, Extend);

    var origBody = superGrammar.rules[name].body;
    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(Extend).call(this, [body, origBody]));
    _this5.superGrammar = superGrammar;
    _this5.name = name;
    _this5.body = body;
    return _this5;
  }

  return Extend;
}(Alt); // Splice is an implementation detail of rule overriding with the `...` operator.


var Splice =
/*#__PURE__*/
function (_Alt2) {
  _inherits(Splice, _Alt2);

  function Splice(superGrammar, ruleName, beforeTerms, afterTerms) {
    var _this6;

    _classCallCheck(this, Splice);

    var origBody = superGrammar.rules[ruleName].body;
    _this6 = _possibleConstructorReturn(this, _getPrototypeOf(Splice).call(this, [].concat(_toConsumableArray(beforeTerms), [origBody], _toConsumableArray(afterTerms))));
    _this6.superGrammar = superGrammar;
    _this6.ruleName = ruleName;
    _this6.expansionPos = beforeTerms.length;
    return _this6;
  }

  return Splice;
}(Alt); // Sequences


var Seq =
/*#__PURE__*/
function (_PExpr5) {
  _inherits(Seq, _PExpr5);

  function Seq(factors) {
    var _this7;

    _classCallCheck(this, Seq);

    _this7 = _possibleConstructorReturn(this, _getPrototypeOf(Seq).call(this));
    _this7.factors = factors;
    return _this7;
  }

  return Seq;
}(PExpr); // Iterators and optionals


var Iter =
/*#__PURE__*/
function (_PExpr6) {
  _inherits(Iter, _PExpr6);

  function Iter(expr) {
    var _this8;

    _classCallCheck(this, Iter);

    _this8 = _possibleConstructorReturn(this, _getPrototypeOf(Iter).call(this));
    _this8.expr = expr;
    return _this8;
  }

  return Iter;
}(PExpr);

var Star =
/*#__PURE__*/
function (_Iter) {
  _inherits(Star, _Iter);

  function Star() {
    _classCallCheck(this, Star);

    return _possibleConstructorReturn(this, _getPrototypeOf(Star).apply(this, arguments));
  }

  return Star;
}(Iter);

var Plus =
/*#__PURE__*/
function (_Iter2) {
  _inherits(Plus, _Iter2);

  function Plus() {
    _classCallCheck(this, Plus);

    return _possibleConstructorReturn(this, _getPrototypeOf(Plus).apply(this, arguments));
  }

  return Plus;
}(Iter);

var Opt =
/*#__PURE__*/
function (_Iter3) {
  _inherits(Opt, _Iter3);

  function Opt() {
    _classCallCheck(this, Opt);

    return _possibleConstructorReturn(this, _getPrototypeOf(Opt).apply(this, arguments));
  }

  return Opt;
}(Iter);

Star.prototype.operator = '*';
Plus.prototype.operator = '+';
Opt.prototype.operator = '?';
Star.prototype.minNumMatches = 0;
Plus.prototype.minNumMatches = 1;
Opt.prototype.minNumMatches = 0;
Star.prototype.maxNumMatches = Number.POSITIVE_INFINITY;
Plus.prototype.maxNumMatches = Number.POSITIVE_INFINITY;
Opt.prototype.maxNumMatches = 1; // Predicates

var Not =
/*#__PURE__*/
function (_PExpr7) {
  _inherits(Not, _PExpr7);

  function Not(expr) {
    var _this9;

    _classCallCheck(this, Not);

    _this9 = _possibleConstructorReturn(this, _getPrototypeOf(Not).call(this));
    _this9.expr = expr;
    return _this9;
  }

  return Not;
}(PExpr);

var Lookahead =
/*#__PURE__*/
function (_PExpr8) {
  _inherits(Lookahead, _PExpr8);

  function Lookahead(expr) {
    var _this10;

    _classCallCheck(this, Lookahead);

    _this10 = _possibleConstructorReturn(this, _getPrototypeOf(Lookahead).call(this));
    _this10.expr = expr;
    return _this10;
  }

  return Lookahead;
}(PExpr); // "Lexification"


var Lex =
/*#__PURE__*/
function (_PExpr9) {
  _inherits(Lex, _PExpr9);

  function Lex(expr) {
    var _this11;

    _classCallCheck(this, Lex);

    _this11 = _possibleConstructorReturn(this, _getPrototypeOf(Lex).call(this));
    _this11.expr = expr;
    return _this11;
  }

  return Lex;
}(PExpr); // Rule application


var Apply =
/*#__PURE__*/
function (_PExpr10) {
  _inherits(Apply, _PExpr10);

  function Apply(ruleName) {
    var _this12;

    var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, Apply);

    _this12 = _possibleConstructorReturn(this, _getPrototypeOf(Apply).call(this));
    _this12.ruleName = ruleName;
    _this12.args = args;
    return _this12;
  }

  _createClass(Apply, [{
    key: "isSyntactic",
    value: function isSyntactic() {
      return common.isSyntactic(this.ruleName);
    } // This method just caches the result of `this.toString()` in a non-enumerable property.

  }, {
    key: "toMemoKey",
    value: function toMemoKey() {
      if (!this._memoKey) {
        Object.defineProperty(this, '_memoKey', {
          value: this.toString()
        });
      }

      return this._memoKey;
    }
  }]);

  return Apply;
}(PExpr); // Unicode character


var UnicodeChar =
/*#__PURE__*/
function (_PExpr11) {
  _inherits(UnicodeChar, _PExpr11);

  function UnicodeChar(category) {
    var _this13;

    _classCallCheck(this, UnicodeChar);

    _this13 = _possibleConstructorReturn(this, _getPrototypeOf(UnicodeChar).call(this));
    _this13.category = category;
    _this13.pattern = UnicodeCategories[category];
    return _this13;
  }

  return UnicodeChar;
}(PExpr); // --------------------------------------------------------------------
// Exports
// --------------------------------------------------------------------


exports.PExpr = PExpr;
exports.any = any;
exports.end = end;
exports.Terminal = Terminal;
exports.Range = Range;
exports.Param = Param;
exports.Alt = Alt;
exports.Extend = Extend;
exports.Splice = Splice;
exports.Seq = Seq;
exports.Iter = Iter;
exports.Star = Star;
exports.Plus = Plus;
exports.Opt = Opt;
exports.Not = Not;
exports.Lookahead = Lookahead;
exports.Lex = Lex;
exports.Apply = Apply;
exports.UnicodeChar = UnicodeChar; // --------------------------------------------------------------------
// Extensions
// --------------------------------------------------------------------

require('./pexprs-allowsSkippingPrecedingSpace');

require('./pexprs-assertAllApplicationsAreValid');

require('./pexprs-assertChoicesHaveUniformArity');

require('./pexprs-assertIteratedExprsAreNotNullable');

require('./pexprs-check');

require('./pexprs-eval');

require('./pexprs-getArity');

require('./pexprs-generateExample');

require('./pexprs-outputRecipe');

require('./pexprs-introduceParams');

require('./pexprs-isNullable');

require('./pexprs-substituteParams');

require('./pexprs-toDisplayString');

require('./pexprs-toArgumentNameList');

require('./pexprs-toFailure');

require('./pexprs-toString');